import brand from '@helpers/brand';
import { Device, until } from '@helpers/media';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { buttonTheme } from '../ButtonShared.styles';
const Button = styled.button `
  display: inline-flex;
  align-items: center;
  border: 0;
  background-color: var(--buttonBgColor);
  border: 1px solid var(--buttonBorderColor);
  border-radius: 50%;
  color: var(--buttonColor);
  height: 48px;
  justify-content: flex-start;
  margin: 0;
  outline: none;
  padding: 0;
  place-content: center;
  place-items: center;
  text-decoration: none;
  transition: background-color 0.15s ease-out, background-size 0.15s ease-out,
    border-color 0.15s ease-out, color 0.15s ease-out, opacity 0.15s ease-out,
    transform 0.15s ease-out;
  user-select: none;
  width: 48px;

  &:disabled {
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }

  @media ${until(Device.Tablet)} {
    height: 40px;
    width: 40px;
  }

  ${({ themeOption }) => themeOption === 'green' &&
    css `
      ${buttonTheme({
        bgColor: brand.htaRebrand.green,
        borderColor: brand.htaRebrand.green,
        fgColor: brand.white,
    })}

      .theme-apl & {
        ${buttonTheme({
        bgColor: brand.apl.green,
        borderColor: brand.apl.green,
        fgColor: brand.white,
    })}
      }

      .theme-hh & {
        ${buttonTheme({
        bgColor: brand.hortHouse.green,
        borderColor: brand.hortHouse.green,
        fgColor: brand.white,
    })}
      }

      &:hover {
        ${buttonTheme({
        bgColor: brand.htaRebrand.greenLight,
        borderColor: brand.htaRebrand.greenLight,
        fgColor: brand.white,
    })}

        .theme-apl & {
          ${buttonTheme({
        bgColor: brand.apl.greenAlt,
        borderColor: brand.apl.greenAlt,
        fgColor: brand.white,
    })}
        }

        .theme-hh & {
          ${buttonTheme({
        bgColor: brand.hortHouse.greenAlt,
        borderColor: brand.hortHouse.greenAlt,
        fgColor: brand.white,
    })}
        }
      }
    `}

  ${({ themeOption }) => themeOption === 'greenOutline' &&
    css `
      ${buttonTheme({
        bgColor: rgba(brand.hta.green, 0),
        borderColor: brand.hta.green,
        fgColor: brand.black,
    })}

      .theme-apl & {
        ${buttonTheme({
        bgColor: rgba(brand.apl.green, 0),
        borderColor: brand.apl.green,
        fgColor: brand.black,
    })}
      }

      .theme-hh & {
        ${buttonTheme({
        bgColor: rgba(brand.hortHouse.green, 0),
        borderColor: brand.hortHouse.green,
        fgColor: brand.black,
    })}
      }

      &:hover {
        ${buttonTheme({
        bgColor: brand.hta.greenLight,
        borderColor: brand.hta.green,
        fgColor: brand.black,
    })}

        .theme-apl & {
          ${buttonTheme({
        bgColor: brand.apl.greenLight,
        borderColor: brand.apl.green,
        fgColor: brand.black,
    })}
        }

        .theme-hh & {
          ${buttonTheme({
        bgColor: brand.hortHouse.greenLight,
        borderColor: brand.hortHouse.green,
        fgColor: brand.black,
    })}
        }
      }
    `}

  ${({ themeOption }) => themeOption === 'aplGreen' &&
    css `
      ${buttonTheme({
        bgColor: brand.apl.green,
        borderColor: brand.apl.green,
        fgColor: brand.black,
    })}

      &:hover {
        ${buttonTheme({
        bgColor: brand.apl.greenLight,
        borderColor: brand.apl.greenLight,
        fgColor: brand.black,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'aplGreenOutline' &&
    css `
      ${buttonTheme({
        bgColor: rgba(brand.apl.green, 0),
        borderColor: brand.apl.green,
        fgColor: brand.black,
    })}

      &:hover {
        ${buttonTheme({
        bgColor: brand.apl.greenLight,
        borderColor: brand.apl.green,
        fgColor: brand.black,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'white' &&
    css `
      ${buttonTheme({
        bgColor: brand.white,
        borderColor: brand.white,
        fgColor: brand.black,
    })}

      &:hover {
        ${buttonTheme({
        bgColor: '#383838',
        borderColor: brand.white,
        fgColor: brand.white,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'whiteOutline' &&
    css `
      ${buttonTheme({
        bgColor: rgba('#383838', 0),
        borderColor: brand.white,
        fgColor: brand.white,
    })}

      &:hover {
        ${buttonTheme({
        bgColor: '#383838',
        borderColor: brand.white,
        fgColor: brand.white,
    })}
      }
    `}
`;
export default {
    Button,
};
